import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';

import { IOverchargeRfcDialogProperties } from './OverchargeRfcDialog.properties';
import OverchargeRfcForm from './OverchargeRfcDialog.form';
import SummaryTable from 'components/common/SummaryTable';
import OverchargeSummaryTableSchema from './OverchargeRfcDialog.summaryTable.schema';

const OverchargeRfcDialog = (props: IOverchargeRfcDialogProperties): JSX.Element => {
  const { open, onCancel, initialValues, onOk, values, isProcessing } = props;

  const getActions = () => {
    return [
      {
        title: 'Ok',
        disabled: isProcessing,
        iconName: 'CheckCircle',
        isDefault: true,
        listener: async () => {
          onOk(values?.NoticeMessage);
        }
      },
      {
        title: 'Cancel',
        iconName: 'Cancel',
        listener: () => {
          if (onCancel) {
            onCancel();
          }
        },
      },
    ];
  };

  return (
    <div>
      <FormViewModal
        open={open}
        loading={!initialValues}
        title='Overcharge RFC Details'
        subTitle='This program will create an Overcharge RFC and process it against the invoice.'
        headerStyles={{ minHeight: 80 }}
        formProps={{
          formSchema: OverchargeRfcForm,
          initialValues: initialValues?.inlineObject,
          valuesSchema: initialValues?.schema,
          enableReinitialize: true,
          formContainerStyles: { minWidth: 455 },
          smallDialog: true,
          style: { width: 'auto' },
          summaryTableRenderer: () => <div style={{ marginTop: 25 }}>
            <SummaryTable loadingOverchargeDialogSummary={false}
              overchargeDialogSummary={initialValues?.inlineObject}
              paperStyles={{
                style: {
                  margin: '17px 34px 0px 0px'
                }
              }}
              data={
                OverchargeSummaryTableSchema
              }
            /></div>
        }}
        actions={getActions()}
        dialogActionsButtons={true}
        dialogActionsShadow={false}
      />
    </div>
  );
};

export default OverchargeRfcDialog;
